import { ROOT_MEDIA } from 'shared-base';

const pngs = {
  black: `${ROOT_MEDIA}/p-black.png`,
  blue: `${ROOT_MEDIA}/p-blue.png`,
  white: `${ROOT_MEDIA}/p-white.png`,
};

export const defaultTextureMaps: Partial<ITexture> = {
  albedoMapUrl: pngs.white,
  aoMapUrl: pngs.white,
  displacementMapUrl: pngs.black,
  normalMapUrl: pngs.blue,
  metallicMapUrl: pngs.black,
  roughnessMapUrl: pngs.white,
};

export const parseMaterial = (material: Partial<IMaterial>): Partial<IMaterial> => {
  const output = { ...material };

  if (!output.texture) {
    return output;
  }

  output.texture = { ...defaultTextureMaps, ...output.texture };
  return output;
};
